import { render, staticRenderFns } from "./RecipeImageForm.vue?vue&type=template&id=ba90b748&scoped=true"
import script from "./RecipeImageForm.vue?vue&type=script&lang=js"
export * from "./RecipeImageForm.vue?vue&type=script&lang=js"
import style0 from "./RecipeImageForm.vue?vue&type=style&index=0&id=ba90b748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba90b748",
  null
  
)

export default component.exports